import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'; // for React and Vue
import { emitInspectionCompletedForDashboard } from '../../../../plugins/socket';
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {

    data()
    {
        return {
            notyf,
        }
    },

    watch:{

        async 'room.associate_id'(val)
        {
            if(this.associate_counter)
            {
                if(val !== '')
                {
                    this.loader(true)

                    let json_request = {
                        inspection_room_id: this.room.id,
                        employee_associate: true,
                        associate_id: val,
                    }

                    let response = await this.get(`${this.lite_rest_api}/${JSON.stringify(json_request)}`)

                    if(response.status)
                    {
                        this.master_step_codes.map(item => item.associate_id = val)

                        notyf.success('Success')
                        this.loader()
                    }
                    else
                    {
                        this.error_handling(response)
                        this.loader()
                    }
                }
            }
            this.associate_counter++
        },

        async 'room.employee_firm' (val)
        {
            if (val)
            {
                this.$refs.signaturePad.fromDataURL(val)
                this.$refs.signaturePad.resizeCanvas()
                this.$refs.signaturePad.lockSignaturePad()
            }
        },

        async master_room_id(room_id)
        {
            if(room_id)
            {
                this.master_room_name = this.parent.rooms.find(item => item.id === room_id).name

                let json_request = {
                    master_step_code_rooms: true,
                    inspection_id: this.param_id,
                    room_id,
                }

                let route = `${this.lite_rest_api}/${JSON.stringify(json_request)}`

                this.loader(true)

                let response = await this.get(route)

                if(response.status)
                {
                    this.$refs.signaturePad.resizeCanvas()
                    this.$refs.signaturePad.clearSignature()
                    this.$refs.signaturePad.openSignaturePad()

                    this.room = response.data.room
                    this.room_images_count = response.data.images_count

                    let master_step_code_rooms = response.data.master_step_code_rooms

                    this.master_step_codes = response.data.master_step_codes

                    this.master_step_codes.map((item) =>
                    {
                        item.inspection_id          = this.parent_id
                        item.inspection_room_id     = this.room.id
                    })

                    if(master_step_code_rooms.length)
                    {
                        master_step_code_rooms.forEach((item) => {
                            this.master_step_codes.push(item)
                        })
                    }

                    // this.master_step_codes.map((item) =>
                    // {
                    //     if(item.associate_id === '' || item.associate_id === null)
                    //     {
                    //         item.associate_id = this.room.associate_id
                    //     }
                    // })
                }

                this.loader()
            }
        },

    },

    methods: {

        async overrideItem(index)
        {
            if(this.master_step_codes[index].require_correction)
            {
                let confirmation = window.confirm('Are you sure you want to override the correction requirement?')
                if(confirmation)
                {
                    let json_request = {
                        override: true
                    }

                    this.loader(true)

                    let response = await this.patch(`${this.child_api}/${JSON.stringify(json_request)}`, this.master_step_codes[index])
                
                    if(response.status)
                    {
                        this.master_step_codes[index].require_correction = false
                        window.$(`#requirescorrection${index}`).prop('checked', false)
                        notyf.success('Success')
                        this.loader()
                    }
                    else
                    {
                        this.error_handling(response)
                        this.loader()
                    }
                }
            }
        },

        isDisabled()
        {
            // console.log(this.room.completed_date,);
            if(this.room.completed_date && !this.hasPermissions(['QC-Inspection Write Completed Inspections']))
            {
                return true
            }
            else
            {
                return false
            }
        },

        async gettingGlobalPassingPorcentage()
        {
            let json_request = {
                global_porcentage: true,
                inspection_id: this.param_id,
            }

            let route = `${this.lite_rest_api}/${JSON.stringify(json_request)}`

            let response = await this.get(route)

            if(response.status)
            {
                this.global_passing_percentage = response.data.global_percentage
            }

            this.loader()
        },

        async complete_inspection(open_modal = false)
        {
            let filter_correction = this.master_step_codes.filter( item => item.score === 2 && item.require_correction && !item.corrected )

            if(filter_correction.length)
            {
                window.alert(`This room is being completed with items needing correction. If you need to, return to this room to correct failed items by selecting it from the room's dropdown. The room status will remain as "incomplete" until the failed items have been corrected.`)
                return false
            }

            let confirmation = open_modal ? window.confirm('Are you sure you want to mark this room as complete?') : true

            if(confirmation)
            {

                let json_request = {
                    complete_room: true,
                    inspection_room_id: this.room.id,
                    inspection_id: this.parent_id,
                    associate_id: this.room.associate_id
                }
                
                if(open_modal && (!json_request.associate_id || json_request.associate_id === undefined))
                {
                    window.$('#associate-warning-modal').modal('show')
                    return false
                }
                else
                {
                    this.loader(true)
                    await this.updateFirmAndComment(false, true)

                    window.$('#associate-warning-modal').modal('hide')
                    let response = await this.get(`${this.lite_rest_api}/${JSON.stringify(json_request)}`)
                    this.loader()
                    if(response.status)
                    {
                        const data = response.data
                        this.associate_counter = 0
                        this.room = {associate_id: data.inspection_room.associate_id ? data.inspection_room.associate_id : '', ...data.inspection_room}

                        let index = this.parent.rooms.findIndex(item => item.id == this.master_room_id)

                        if(index > -1)
                        {
                            this.parent.rooms[index].completed_date = 'today'
                        }

                        if(data.inspection_status)
                        {
                            emitInspectionCompletedForDashboard(this.get_user().facility_id)
                            // this.sendInspectionReport(false)
                            this.parent.completed_date = data.inspection_status

                            if(data.associates.length)
                            {
                                this.$refs.mail_inspection_modal.setAssociates(data.associates)
                                window.$('#mail-inspection-modal').modal('show')
                            }
                        }

                        this.notyfMesg('Success')
                    }
                    else
                    {
                        this.error_handling(response)
                    }
                }
            }
        },


        async openSelectAssociateModal()
        {
            if(!this.parent.associate_id && !this.parent.inspection_report)
            {
                window.$('#associate-selection-modal').modal('show')
                return true
            }
            else
            {
                this.sendInspectionReport(false)
            }
        },

        async sendInspectionReport(event)
        {
            this.loader(true)

            let obj = {
                inspection_id: this.parent_id,
                associate_id: event && typeof event === 'object' && event.associate_id ? event.associate_id : this.parent.associate_id
            }

            const response = await this.post(`${this.lite_rest_api}/post/send_copy_inspections_individually`, obj)

            if(response.status)
            {
                setTimeout(() => {
                    window.$('#confirmation-modal').modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
            }

            this.loader()
        },

        async cancelComplete(inspection_room_id)
        {
            this.loader(true)
            let json_request = {
                inspection_id: this.param_id,
                cancel_complete: true,
                inspection_room_id
            }

            let response = await this.get(`${this.lite_rest_api}/${JSON.stringify(json_request)}`)
            if(response.status)
            {
                this.parent.status = response.data.data.status
                this.loader()
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        async listener(index, data_name)
        {
            this.single_object = { ...this.master_step_codes[index] }

            // data_name === 'require_correction' ? this.single_object.require_correction ? this.single_object.score = 2 : null : null
            // data_name === 'score' ? this.single_object.score === 2 ? this.single_object.require_correction = true : this.single_object.require_correction = false : null

            if(data_name === 'score')
            {
                if(this.single_object.score === 2)
                {
                    this.single_object.require_correction = true
                    this.cancelComplete(this.single_object.inspection_room_id)
                }
                else
                {
                    this.single_object.require_correction = false
                }
            }
            else if(data_name === 'corrected')
            {
                if(this.single_object.score === 2)
                {
                    this.cancelComplete(this.single_object.inspection_room_id)
                }
            }

            let response = this.single_object.id !== '' ? await this.patch(`${this.child_api}/${this.single_object.id}`, this.single_object) : await this.post(this.child_api, this.single_object)

            data_name !== 'comment' ? this.loader(true) : null

            if(response.status)
            {
                this.master_step_codes.splice(index, 1, response.data.data)
                notyf.success('Success')
                data_name !== 'comment' ? this.loader() : null
            }
            else
            {
                this.error_handling(response)
                data_name !== 'comment' ? this.loader() : null
            }

            this.gettingGlobalPassingPorcentage()
        },

        unshift_object(new_object)
        {
            this.codes.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.codes.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility)
            {
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.codes[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.codes[index]
            
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.parent             = data.inspection
            this.parent_id          = data.parent_id
            this.incial_comment     = this.parent.manager_comment

            this.parent_array_options = {
                supervisors: data.supervisors,
            }

            this.array_options = {
                associates: data.associates,
                employee_associate_id: data.associates,
                new_inspection_room_images: 'image/jpeg, image/png, image/jpg, image/webp'
            }

            this.breadcrumb.push({
                name: `Inspection - ${this.parent.title}`,
                href: this.current_url,
                arrow: "",
            })
            
            this.parent.room_id.length ? this.master_room_id = this.parent.room_id[0] : null
            
        },

        trashing(index)
        {
            this.codes.splice(index, 1)
        },

        resize()
        {
            this.window_width = window.innerWidth
        },

        async update_comment()
        {
            this.loader(true)
            const response = await this.patch(this.rest_api, this.parent)
            if (response.status)
            {
                notyf.success('Comment Saved')
                this.loader()
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        async updateFirmAndComment(from_comment = false, saving_all = false)
        {
            let http_object = {}

            if(from_comment || saving_all)
            {
                http_object['manager_comment'] = this.room.manager_comment
            }

            if(!from_comment || saving_all)
            {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature()

                if(this.room.employee_firm)
                {
                    if(!saving_all)
                    {
                        return notyf.success('The Signature was already saved')
                    }
                }
                else if(isEmpty)
                {
                    if(!saving_all)
                    {
                        return notyf.error('The Signature must not be empty')
                    }
                }
                else
                {
                    http_object['file'] = data
                }
            }

            this.loader(true)

            const response = await this.put(`${this.lite_rest_api}/update_signature/${this.room.id}`, http_object)
            
            if(response.status)
            {
                if(!saving_all)
                {
                    if(from_comment)
                    {
                        notyf.success('Manager Comments Saved')
                    }
                    if(!from_comment)
                    {
                        notyf.success('Signature Saved')
                        this.$refs.signaturePad.lockSignaturePad()
                    }
                }
                else
                {
                    this.$refs.signaturePad.lockSignaturePad()
                }
                this.loader()
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        clear_firm()
        {
            this.$refs.signaturePad.resizeCanvas()
            this.$refs.signaturePad.clearSignature()
            this.$refs.signaturePad.openSignaturePad()
            this.room.employee_firm = null
        },

        back_to()
        {
            window.location.href = '/qc-inspection'
        },

        async uploadInspectionRoomImages()
        {
            if(!this.form_data.new_inspection_room_images.length)
            {
                this.notyfMesg('You must upload at least one image to proceed.', 'error')
                return
            }
            else if(this.form_data.new_inspection_room_images.length > 5)
            {
                this.notyfMesg('You cannot upload more than five images.', 'error')
                return
            }
            this.loader(true)

            const res = await this.post('inspection/upload/images', {...this.form_data, id: this.room.id})

            this.loader()

            if(res.status)
            {
                this.afterSaved()
            }
            else
            {
                this.error_handling(res)
            }
        },
        openImagesModal()
        {
            this.getRoomImages()
            window.$('#static-inspection-room-images').modal('show')
        },

        async getRoomImages()
        {
            this.is_loading_images = true
            let json_request = {
                get_associated_inspection_room_images: true,
                inspection_room_id: this.room.id,
            }

            let route = `${this.lite_rest_api}/${JSON.stringify(json_request)}`

            let response = await this.get(route)

            this.is_loading_images = false

            if(response.status)
            {
                this.inspection_room_images = response.data.data
                this.room_images_count = this.inspection_room_images.length
            }
            else
            {
                this.error_handling(response)
            }
        },

        nextImage()
        {
            if(this.index_active < (this.inspection_room_images.length - 1))
            {
                this.index_active++
            }
            else
            {
                this.index_active = 0
            }
        },

        previousImage()
        {
            if(this.index_active > 0)
            {
                this.index_active--
            }
            else
            {
                this.index_active = this.inspection_room_images.length - 1
            }
        },

        async removeRoomImage({id, index})
        {
            window.$('#static-inspection-room-images').modal('hide')
            this.index_active = 0
            this.loader(true)

            let json_request = {
                remove_associated_inspection_room_images: true,
                id: id,
            }

            const response = await this.get(`${this.lite_rest_api}/${JSON.stringify(json_request)}`)
            this.loader()

            setTimeout(() => {
                window.$('#static-inspection-room-images').modal('show')
            }, 300);

            if(response.status)
            {
                this.room_images_count--
                this.inspection_room_images.splice(index, 1)
            }
            else
            {
                this.error_handling(response)
            }
        },

        afterSaved()
        {
            this.getRoomImages()
            this.form_data.new_inspection_room_images = []
        },
        
    }

}

export default Methods
